import React from 'react'
import { useTranslation } from 'react-i18next'

import RadioBlock from '../../../../../../../components/Form/RadioBlock'

import {
  AD_TYPE_OPTION,
  VIDEO_EXISTING_LIBRARY_TYPE,
  VIDEO_EXTERNAL_HOST_TYPE,
  VIDEO_UPLOAD_TYPE,
  VIDEO_VAST_XML_TYPE
} from '../../fields'

const VideoOptions = ({ chooseRoute, setChooseRoute }) => {
  const { t } = useTranslation()

  // The answers to this question will define which route the user takes (Route A, Route B or Route C)
  return (
    <>
      <RadioBlock
        setFieldValue={(fieldName, route) => setChooseRoute(route)}
        id="radio_type_upload_video"
        name={AD_TYPE_OPTION}
        value={VIDEO_UPLOAD_TYPE}
        selectedValue={chooseRoute}
        label={t('Upload video creatives')}
      />
      <RadioBlock
        setFieldValue={(fieldName, route) => setChooseRoute(route)}
        id="radio_type_external_host"
        name={AD_TYPE_OPTION}
        value={VIDEO_EXTERNAL_HOST_TYPE}
        selectedValue={chooseRoute}
        label={t('Use video creatives from an external host')}
      />
      <RadioBlock
        setFieldValue={(fieldName, route) => setChooseRoute(route)}
        id="radio_type_vast_xml"
        name={AD_TYPE_OPTION}
        value={VIDEO_VAST_XML_TYPE}
        selectedValue={chooseRoute}
        label={t('Provide URL to VAST XML file')}
      />
      <RadioBlock
        setFieldValue={(fieldName, route) => setChooseRoute(route)}
        id="radio_type_existing_library"
        name={AD_TYPE_OPTION}
        value={VIDEO_EXISTING_LIBRARY_TYPE}
        selectedValue={chooseRoute}
        label={t('Use existing video from the library')}
      />
    </>
  )
}

export default VideoOptions
